import cn from 'classnames';
import { SelectHTMLAttributes } from 'react';
import styles from './NativeSelect.module.scss';

type NativeSelectProps = {
  selectClassName?: string;
  wrapperClassName?: string;
  dateListClassName?: string;
  data: Array<string>;
} & SelectHTMLAttributes<HTMLSelectElement>;

const NativeSelect = ({
  selectClassName = '',
  wrapperClassName = '',
  dateListClassName = '',
  name,
  data,
  value,
  onChange,
}: NativeSelectProps) => (
  <div className={cn(styles.selectWrap, wrapperClassName)}>
    <select className={cn(styles.select, selectClassName)} name={name} id={name} value={value} onChange={onChange}>
      {data.map((item) => (
        <option value={item} className={cn(styles.item, dateListClassName)} key={item}>
          {item}
        </option>
      ))}
    </select>
  </div>
);

export default NativeSelect;
